"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactDropdownMenu = require("@radix-ui/react-dropdown-menu");
var _colors = _interopRequireDefault(require("../../styles/colors"));
var HBMenuItemDivider = function HBMenuItemDivider(_ref) {
  var margin = _ref.margin;
  return /*#__PURE__*/_react["default"].createElement(Divider, {
    margin: margin
  });
};
var _default = exports["default"] = HBMenuItemDivider;
var Divider = (0, _styledComponents["default"])(_reactDropdownMenu.Separator).withConfig({
  displayName: "HBMenuItemDivider__Divider",
  componentId: "sc-1g6s29k-0"
})(["margin:", ";height:1px;background-color:", ";"], function (_ref2) {
  var margin = _ref2.margin;
  return margin;
}, _colors["default"].neutral200);
//# sourceMappingURL=HBMenuItemDivider.js.map